import EditIcon from '@mui/icons-material/Edit';
import { Button } from '@mui/material';
import { useCustomNavigate } from 'utils/hooks/useCustomNavigate';
import strings from '../../../../common/Translation/Translate';
import { routes } from '../../../../utils/constants/routes';
import { bookingDetailToolbarButtonSx } from '../bookingDetailToolbarSx';

type EditButtonProps = {
  id: any;
  /** Toolbar layout: no full-width stretch */
  compact?: boolean;
};
export const EditButton: React.FC<EditButtonProps> = ({ id, compact = false }) => {
  const Navigate = useCustomNavigate();
  return (
    <>
      <Button
        fullWidth={!compact}
        size={compact ? 'small' : 'medium'}
        onClick={() => Navigate(`${routes.editBooking}/${id}`)}
        variant="contained"
        color="info"
        sx={compact ? { ...bookingDetailToolbarButtonSx, my: 0 } : { minHeight: '36px', my: 1 }}
        startIcon={<EditIcon />}>
        {strings.BookingDetailButonTextEdit}
      </Button>
    </>
  );
};
